const APIS = {
  TICKET: '/helpdeskservice/api/ticket/',
  TICKET_QUEUE: '/helpdeskservice/api/queue/',
  USER: '/usermanagementservice/api/user/',
  BRANCH: '/logisticservice/api/branch/',
  COMMENT: '/commentservice/api/comment/',
};

export default APIS;
